/** Встроенные браузеры мессенджеров (Telegram, Instagram и т.д.) — частый источник «белого экрана». */

export function detectInAppBrowser() {
  if (typeof navigator === 'undefined') {
    return { telegram: false, instagram: false, facebook: false, line: false, ios: false, any: false };
  }

  const ua = navigator.userAgent || '';
  const telegram = /Telegram/i.test(ua)
    || typeof window.TelegramWebviewProxy !== 'undefined'
    || Boolean(window.Telegram?.WebApp);

  const instagram = /Instagram/i.test(ua);
  const facebook = /FBAN|FBAV/i.test(ua);
  const line = /\bLine\//i.test(ua);
  const ios = /iPhone|iPad|iPod/i.test(ua);
  const any = telegram || instagram || facebook || line;

  return { telegram, instagram, facebook, line, ios, any };
}

export function isWebKit() {
  if (typeof navigator === 'undefined') return false;
  return /AppleWebKit/i.test(navigator.userAgent || '');
}

/** Safari / iOS / Telegram WebView: таймеры и fetch могут «спать» минутами — не блокируем UI. */
export function shouldUseFastBoot() {
  return isWebKit() || isInAppBrowser();
}

export function isTelegramWebView() {
  return detectInAppBrowser().telegram;
}

export function isInAppBrowser() {
  return detectInAppBrowser().any;
}

/** Service Worker в WebView Telegram на iOS часто ломает или подвешивает старт. */
export function shouldRegisterServiceWorker() {
  return !isInAppBrowser();
}
